"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _index = require("@/utils/index");
var _agendaLabels = require("@/utils/agendaLabels");
var _admin = require("@/store/modules/admin");
var _leads = require("@/api/leads");
var _followUps = require("@/api/follow-ups");
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.agendaLabels = _agendaLabels.agendaLabels;
    this.list = [];
    this.startDate = '';
    this.endDate = '';
    this.loggedInUser = null;
    this.listQuery = {
      page: 1,
      limit: 10,
      enabled: true,
      status: undefined
    };
  }
  created() {
    this.loggedInUser = _admin.AdminModule;
    if (this.dateRange && this.dateRange.start && this.dateRange.end) {
      this.startDate = this.dateRange.start;
      this.endDate = this.dateRange.end;
    }
    this.fetchData();
  }
  handleChange(status = null) {
    if (!status) {
      this.listQuery.status = undefined;
      this.fetchData();
    } else {
      this.listQuery.status = status;
      this.fetchData();
    }
  }
  async fetchData() {
    this.listQuery.assignedTo = this.loggedInUser.id;
    if (!['Super Admin', 'System Admin', 'Admin'].includes(_admin.AdminModule.roles.toString())) {
      // add id to these fields
      this.listQuery.salesManagerId = _admin.AdminModule.id;
    }
    const response = await (0, _leads.getLeads)((0, _index.getQuery)(this.listQuery));
    // response.data.followUp.sort((followUp1: any, followUp2: any) => followUp1.id - followUp2.id);
    for (const lead of response.data) {
      const followUp = await (0, _followUps.getFollowUps)((0, _index.getQuery)({
        limit: 1,
        leadId: lead.id,
        type: 'Lead',
        enabled: true,
        sort: 'id,DESC',
        filter: {
          assignedTo: '$eq',
          enabled: '$eq',
          type: '$eq',
          status: '$eq'
        }
      }));
      lead.followUp = followUp[0];
    }
    this.list = response.data;
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: ''
})], default_1.prototype, "dateRange", void 0);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LeadsTable',
  components: {}
})], default_1);
var _default = exports.default = default_1;